import React from "react";
import { Route, Redirect } from "react-router-dom";
import AdminLayout from "../containers/layout/adminLayout";
import ErrorBoundary from './ErrorBoundary';

const AdminRoute = ({ component: Component, props: cProps, ...rest }) => {
  return (
    <Route
      {...rest}
      render={routeProps => (
        <ErrorBoundary>
          <AdminLayout
            {...routeProps}
            {...cProps}
          >
            <Component {...routeProps} {...cProps} />
          </AdminLayout>
        </ErrorBoundary>
      )}
    />
  );
};

export default AdminRoute;